import ObserverIndicator from '@/domain/scene/indicators/generic/ObserverIndicator.js'
import { numbFormat } from '@/domain/helpers/MathHelper.js'
import {
  travelTime as relativisticTravelTime,
  timeDilation,
  remoteClockTime,
  lengthEnlargement
} from '@/domain/physics/SpecialRelativity.js'
import { travelTime as classicalTravelTime } from '@/domain/physics/ClassicalMechanics.js'

const NAME = 'ObserverBottomIndicatorLine'
const INIT_X_REL = 0
const INIT_Y_REL = 0.24

export default class ObserverBottomIndicator extends ObserverIndicator {
  constructor () {
    super(
      NAME,
      INIT_X_REL,
      INIT_Y_REL
    )
  }

  _getPos (isObserverInTrain, observerPos, oppositeObjPos, isRelativistic, speedValue) {
    if (isRelativistic) {
      if (isObserverInTrain) {
        return numbFormat(lengthEnlargement(observerPos - oppositeObjPos, speedValue), 1)
      } else {
        return numbFormat(observerPos, 1)
      }
    } else {
      if (isObserverInTrain) {
        return numbFormat(observerPos - oppositeObjPos, 1)
      } else {
        return numbFormat(observerPos, 1)
      }
    }
  }

  _getTime (isObserverInTrain, observerPos, oppositeObjPos, isRelativistic, speedValue) {
    if (isRelativistic) {
      if (isObserverInTrain) {
        let observerPlatformPos = lengthEnlargement(observerPos - oppositeObjPos, speedValue)
        let tt = relativisticTravelTime(-oppositeObjPos, speedValue)
        let dilatedTime = timeDilation(tt, speedValue)
        let rct = remoteClockTime(-observerPlatformPos, dilatedTime, speedValue)
        return numbFormat(rct)
      } else {
        return numbFormat(relativisticTravelTime(oppositeObjPos, speedValue))
      }
    } else {
      if (isObserverInTrain) {
        return numbFormat(classicalTravelTime(-oppositeObjPos, speedValue), 1)
      } else {
        return numbFormat(classicalTravelTime(oppositeObjPos, speedValue), 1)
      }
    }
  }

  setValue (isObserverInTrain, observerPos, oppositeObjPos, isRelativistic, speedValue) {
    let posValue = this._getPos(isObserverInTrain, observerPos, oppositeObjPos, isRelativistic, speedValue)
    let timeValue = this._getTime(isObserverInTrain, observerPos, oppositeObjPos, isRelativistic, speedValue)
    let posUnit = 'm'
    let timeUnit = isRelativistic ? 'ns' : 's'
    this.text = `${timeValue} ${timeUnit}\n${posValue} ${posUnit}`
  }
}
